export default function Spaces(_ref) {
  let {
    spaces,
    activeSpace,
    onSpaceChange
  } = _ref;
  return m('aside.dc-sidebar.dc-sidebar--left', [m('div.dc-card.dc-widget', [m('h3.dc-widget__title', 'Пространства'), m('nav.dc-spaces', {
    'aria-label': 'Пространства сообщества'
  }, spaces.map(space => m('button.dc-space', {
    className: activeSpace === space.slug ? 'is-active' : '',
    key: space.url,
    onclick: () => onSpaceChange(activeSpace === space.slug ? null : space.slug)
  }, [m('span.dc-space__icon', {
    style: `--sp-c:${space.color}`
  }, '{ }'), m('span.dc-space__name', space.name), m('span.dc-space__count', space.discussionCount)]))), m('a.dc-link.dc-link--sm.dc-spaces__all', {
    href: '/tags'
  }, 'Все пространства →')])]);
}
export function SpacesChips(_ref2) {
  let {
    spaces,
    activeSpace,
    onSpaceChange
  } = _ref2;
  return m('div.dc-spaces-chips', spaces.map(space => m('button.dc-schip', {
    className: activeSpace === space.slug ? 'is-active' : '',
    key: space.url,
    onclick: () => onSpaceChange(activeSpace === space.slug ? null : space.slug)
  }, [m('span.dc-schip__icon', {
    style: `--sp-c:${space.color}`
  }, '{ }'), space.name])));
}
flarum.reg.add('devconnect-portal', 'forum/components/Spaces', Spaces);